import SearchCriteria from "./SearchCriteria" ;


  export default  class  SideMenuUtils { public constructor (  ) {
  }
  public static getTabItemNames ( user : string ) : Array<string> {
 let tabItemNames :Array<string>=[  ];

if ( user !== 'Sales Person' ) {
 tabItemNames=[ 'Basic', 'Company Information', 'Interaction & Preferences', 'Family Information' ];
 }

return tabItemNames ; 
 }
  public static getFilterCount ( criteria : SearchCriteria ) : number {
 let count :number=0;

if ( criteria !== null ) {
 if ( criteria.fullName !== null && criteria.fullName !== '' ) {
 count=count + 1;
 }

if ( criteria.personLocations !== null && criteria.personLocations.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.timeZones !== null && criteria.timeZones.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.accountLocation !== null && criteria.accountLocation.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.jobPostingHiringFor !== null && criteria.jobPostingHiringFor.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.jobPostingLocation !== null && criteria.jobPostingLocation.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.jobTitles !== null && criteria.jobTitles.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.languages !== null && criteria.languages.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.keywords !== null && criteria.keywords.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.companyTagIDs !== null && criteria.companyTagIDs.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.technologies !== null && criteria.technologies.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.minYearExp !== null && criteria.minYearExp.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.maxYearExp !== null && criteria.maxYearExp.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.minYearCurrentRole !== null && criteria.minYearCurrentRole.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.maxYearCurrentRole !== null && criteria.maxYearCurrentRole.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.minMonthCurrentRole !== null && criteria.minMonthCurrentRole.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.maxMonthCurrentRole !== null && criteria.maxMonthCurrentRole.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.minGrowPercentage !== null && criteria.minGrowPercentage.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.maxGrowPercentage !== null && criteria.maxGrowPercentage.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.fundingFromDate !== null && criteria.fundingFromDate.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.fundingToDate !== null && criteria.fundingToDate.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.minFundingAmount !== null && criteria.minFundingAmount.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.maxFundingAmount !== null && criteria.maxFundingAmount.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.minFoundedYear !== null && criteria.minFoundedYear.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.maxFoundedYear !== null && criteria.maxFoundedYear.isNotEmpty ) {
 count=count + 1;
 }

if ( criteria.minRetailLocation !== null && !criteria.minRetailLocation.isEmpty ) {
 count=count + 1;
 }

if ( criteria.maxRetailLocation !== null && !criteria.maxRetailLocation.isEmpty ) {
 count=count + 1;
 }

if ( criteria.minJobPosting !== null && !criteria.minJobPosting.isEmpty ) {
 count=count + 1;
 }

if ( criteria.maxJobPosting !== null && !criteria.maxJobPosting.isEmpty ) {
 count=count + 1;
 }

if ( criteria.jobPostedFromDate !== null && !criteria.jobPostedFromDate.isEmpty ) {
 count=count + 1;
 }

if ( criteria.jobPostedToDate !== null && !criteria.jobPostedToDate.isEmpty ) {
 count=count + 1;
 }

if ( criteria.minEmployeeRange !== null && !criteria.minEmployeeRange.isEmpty ) {
 count=count + 1;
 }

if ( criteria.maxEmployeeRange !== null && !criteria.maxEmployeeRange.isEmpty ) {
 count=count + 1;
 }

if ( criteria.timeFrame !== null && !criteria.timeFrame.isEmpty ) {
 count=count + 1;
 }

if ( criteria.department !== null && !criteria.department.isEmpty ) {
 count=count + 1;
 }
 }
 else {
 count=0;
 }

return count ; 
 }
 }